import React, { useState, useEffect } from 'react';
import { Container, Row, Col, InputGroup } from 'react-bootstrap';
import { axiosInstance } from '../../../../../api/axios';
import { HttpSuccessCodes } from '../../../../errorhandling/HttpErrorCodes';
import AddButton from '../../UserFormNew/components/AddButton';
import FilterModal from '../../../../components/common/filter-modal/FilterModal';
import { SearchSVG } from '../../../../img/GlobalSVG';
import TextInput from '../../../../../Components/GenericInputText/TextInput';
import APIEndpoints from '../../../../api/APIEndpoints';
import Lists from '../Lists';
import { useSelector } from 'react-redux';

const PermissionPanel = ({
  createUserFormData,
  deletePermissionId,
  onSelectedPermissionHandler,
  onSetAllPermissions,
  selectedPermissionsData,
  editPermission,
}) => {
  const cacheBuster = (url) => `${url}?cb=${Date.now()}`;

  const [openPermissionModal, setOpenPermissionModal] = useState(false);
  const [permissionData, setPermissionData] = useState(
    createUserFormData.allPermissions,
  );
  const [searchString, setSearchString] = useState('');
  const [searched, setSearched] = useState([]);
  const [searchedData, setSearchedData] = useState([]);
  let flag = false;

  const onChangePermissionHandler = (e) => {
    setSearchString(e.target.value);
    const tempLocation2 = permissionData.filter((permission) =>
      permission?.RoleName?.toLowerCase().includes(
        e.target.value.toLowerCase(),
      ),
    );
    setSearchedData(tempLocation2);
    tempLocation2.map((permission) => {
      if (permission.isChecked === true) {
        return;
      } else {
        flag = true;
      }
    });
    if (!flag) {
      setSearched(tempLocation2);
    } else {
      setSearched([]);
    }
  };

  const handleAddPermission = () => {
    setOpenPermissionModal(true);
  };

  const applyFilterHandler = () => {
    const selectedPermission = permissionData.filter(
      (permission) => permission.isChecked == true,
    );
    onSelectedPermissionHandler(selectedPermission);
    setOpenPermissionModal(false);
    setSearchString('');
    setSearched([]);
  };

  const selectChangeHandler = (e) => {
    const { name, checked } = e.target;
    if (name === 'select-all-permission') {
      if (searchString === '') {
        const tempPermission = permissionData.map((permission) => {
          return { ...permission, isChecked: checked };
        });
        setPermissionData(tempPermission);
        onSetAllPermissions(tempPermission);
      } else {
        const tempPermission = permissionData.map((permission) =>
          permission?.RoleName?.toLowerCase().includes(
            searchString.toLowerCase(),
          )
            ? { ...permission, isChecked: checked }
            : permission,
        );
        const data = tempPermission.filter((blob) => blob.isChecked === true);
        setSearched(data);
        setPermissionData(tempPermission);
        onSetAllPermissions(tempPermission);
      }
    } else {
      if (searchString === '') {
        const tempPermission = permissionData.map((permission) =>
          permission.RoleName === name
            ? { ...permission, isChecked: checked }
            : permission,
        );
        setPermissionData(tempPermission);
        onSetAllPermissions(tempPermission);
      } else {
        const tempPermission2 = permissionData.map((permission) =>
          permission?.RoleName?.toLowerCase().includes(
            searchString.toLowerCase(),
          )
            ? permission.RoleName === name
              ? { ...permission, isChecked: checked }
              : permission
            : permission,
        );
        const tempPermission = tempPermission2.filter((permission) =>
          permission?.RoleName?.toLowerCase().includes(
            searchString.toLowerCase(),
          ),
        );
        //const tempBlob1 = tempBlob.map( blob => blob.BlkOfBusId === name ? { ...blob, isChecked: checked } : blob );
        tempPermission.map((permission) => {
          if (permission.isChecked === true) {
            return;
          } else {
            flag = true;
          }
        });
        if (!flag) {
          setSearched(tempPermission);
        } else {
          setSearched([]);
        }
        setPermissionData(tempPermission2);
        onSetAllPermissions(tempPermission2);
      }
    }
  };

  const isSuperUser = useSelector((state) => state?.user?.userData?.SuperUser);

  const getPermissionData = async () => {
    try {
      const PermissionsListResponse = await axiosInstance.get(
        cacheBuster(
          APIEndpoints.getPermissionsListsUserType() +
            (createUserFormData?.userType?.value && !isSuperUser
              ? `/usertype/${createUserFormData?.userType?.value}/`
              : '/') +
            'pagesize/200/pagenumber/1',
        ),
      );
      if (
        PermissionsListResponse.status ===
        HttpSuccessCodes.HTTP_SUCCESS_CODE_200
      ) {
        console.log(
          'PermissionsListResponse :::: $$$$$ ::::: ',
          PermissionsListResponse,
        );
        if (PermissionsListResponse?.data?.Response?.Roles) {
          setPermissionData(PermissionsListResponse?.data?.Response?.Roles);
          onSetAllPermissions(PermissionsListResponse?.data?.Response?.Roles);

          if (selectedPermissionsData && selectedPermissionsData.length > 0) {
            const permissionList =
              PermissionsListResponse?.data?.Response?.Roles;
            const tempObj = permissionList.map((item) =>
              selectedPermissionsData.filter((selectedItem) =>
                Boolean(selectedItem.RoleName === item.RoleName),
              ).length
                ? { ...item, isChecked: true }
                : item,
            );
            setPermissionData(tempObj);
            onSetAllPermissions(tempObj);
          } else {
            setPermissionData(PermissionsListResponse?.data?.Response?.Roles);
            onSetAllPermissions(PermissionsListResponse?.data?.Response?.Roles);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (deletePermissionId) {
      const tempPermissionData = permissionData.map((permission) =>
        permission.RoleName === deletePermissionId
          ? { ...permission, isChecked: false }
          : permission,
      );
      const checkedPermissionData = tempPermissionData.filter(
        (permission) => permission.isChecked == true,
      );
      onSelectedPermissionHandler(checkedPermissionData);
      setPermissionData(tempPermissionData);
      onSetAllPermissions(tempPermissionData);
    } else {
      if (createUserFormData && createUserFormData.allPermissions.length > 0) {
        if (selectedPermissionsData && selectedPermissionsData.length > 0) {
          const permissionList = createUserFormData.allPermissions;
          const tempObj = permissionList.map((item) =>
            selectedPermissionsData.filter((selectedItem) =>
              Boolean(selectedItem.RoleName === item.RoleName),
            ).length
              ? { ...item, isChecked: true }
              : item,
          );
          setPermissionData(tempObj);
        } else {
          setPermissionData(createUserFormData.allPermissions);
        }
      } else {
        getPermissionData();
      }
    }
  }, [deletePermissionId, selectedPermissionsData]);
  return (
    <>
      {editPermission ? (
        <AddButton
          label="Add Permission Groups"
          onClick={() => handleAddPermission()}
          className={'add-button-active'}
        />
      ) : (
        <AddButton
          label="Add Permission Groups"
          className={'add-button-disable'}
        />
      )}
      <FilterModal
        showBackButton={false}
        isVisible={openPermissionModal}
        onHide={() => {
          setSearchString('');
          setOpenPermissionModal(false);
        }}
        applyFilterHandler={applyFilterHandler}
        showCancel={true}
        titleLabel="Permission(s)"
        showApply={true}
        showApplyLabel="Add Selected"
      >
        {permissionData && Object.keys(permissionData).length ? (
          <Container className="mt-3 mb-3">
            <Row>
              <Col sm={12}>
                <div>
                  <TextInput
                    parentClassName="mb-2"
                    label="Permission"
                    append={
                      <InputGroup.Text>
                        <SearchSVG.SearchSVG className="primary-text-color" />
                      </InputGroup.Text>
                    }
                    inputProps={{
                      type: 'text',
                      placeholder: 'Search',
                      value: searchString,
                      onChange: onChangePermissionHandler,
                      className: 'border-right-0',
                      autoFocus: false,
                      id: 'filter-permission-input',
                    }}
                  />
                </div>
              </Col>
            </Row>
            {searchString === '' ? (
              <>
                <Row>
                  <Col sm={12} className="mt-4 mb-2">
                    <div className=" select-all-row d-flex">
                      <input
                        type="checkbox"
                        id="select-all-permission"
                        name="select-all-permission"
                        className="p-0 mt-auto mb-auto"
                        onChange={(e) => {
                          selectChangeHandler(e);
                        }}
                        checked={
                          searchString === ''
                            ? createUserFormData &&
                              createUserFormData.allPermissions.length > 0
                              ? createUserFormData.allPermissions.filter(
                                  (permission) => permission.isChecked !== true,
                                ).length < 1
                              : permissionData.filter(
                                  (permission) => permission.isChecked !== true,
                                ).length < 1
                            : searched && searched.length > 0
                            ? searched.filter(
                                (permission) => permission.isChecked !== true,
                              ).length < 1
                            : permissionData.filter(
                                (permission) => permission.isChecked !== true,
                              ).length < 1
                        }
                      />
                      <label
                        className="my-auto select-all-checkbox"
                        htmlFor="select-all-permission"
                      >
                        Select All
                      </label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} className="mb-1">
                    <Lists
                      data={
                        createUserFormData &&
                        createUserFormData.allPermissions.length > 0
                          ? createUserFormData.allPermissions
                          : permissionData
                      }
                      selectChangeHandler={selectChangeHandler}
                      searchString={searchString}
                    />
                  </Col>
                </Row>
              </>
            ) : (
              <>
                {searchedData && Object.keys(searchedData).length ? (
                  <>
                    <Row>
                      <Col sm={12} className="mt-4 mb-2">
                        <div className=" select-all-row d-flex">
                          <input
                            type="checkbox"
                            id="select-all-permission"
                            name="select-all-permission"
                            className="p-0 mt-auto mb-auto"
                            onChange={(e) => {
                              selectChangeHandler(e);
                            }}
                            checked={
                              searchString === ''
                                ? createUserFormData &&
                                  createUserFormData.allPermissions.length > 0
                                  ? createUserFormData.allPermissions.filter(
                                      (permission) =>
                                        permission.isChecked !== true,
                                    ).length < 1
                                  : permissionData.filter(
                                      (permission) =>
                                        permission.isChecked !== true,
                                    ).length < 1
                                : searched && searched.length > 0
                                ? searched.filter(
                                    (permission) =>
                                      permission.isChecked !== true,
                                  ).length < 1
                                : permissionData.filter(
                                    (permission) =>
                                      permission.isChecked !== true,
                                  ).length < 1
                            }
                          />
                          <label
                            className="my-auto select-all-checkbox"
                            htmlFor="select-all-permission"
                          >
                            Select All
                          </label>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} className="mb-1">
                        <Lists
                          data={
                            createUserFormData &&
                            createUserFormData.allPermissions.length > 0
                              ? createUserFormData.allPermissions
                              : permissionData
                          }
                          selectChangeHandler={selectChangeHandler}
                          searchString={searchString}
                        />
                      </Col>
                    </Row>
                  </>
                ) : (
                  <Container className="mt-3 mb-3">
                    <div>No Records Found</div>
                  </Container>
                )}
              </>
            )}
          </Container>
        ) : (
          <Container className="mt-3 mb-3">
            <div>No Records Found</div>
          </Container>
        )}
      </FilterModal>
    </>
  );
};

export default PermissionPanel;
